/* unplugin-vue-components disabled */import { render } from "./CustomDialog.vue?vue&type=template&id=60f9ca07"
import script from "./CustomDialog.vue?vue&type=script&lang=js"
export * from "./CustomDialog.vue?vue&type=script&lang=js"

import "./CustomDialog.vue?vue&type=style&index=0&id=60f9ca07&lang=scss"

import exportComponent from "D:\\pangu_artificial_intelligence_ui\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__